import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  inject,
} from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { Router } from '@angular/router';
import {
  Column,
  DataTableComponent,
  EmptyTableComponent,
} from '@nimmsta/ng-commons-lib/data-table';
import { NimmstaTimeAgoPipe } from '@nimmsta/ng-commons-lib/pipes';
import { ScannerStatusPipe } from './status.pipe';
import { ScannerDatasource } from '../../services/scanner.datasource';
import { WorkerNamePipe } from './workerNamePipe';
import { TranslatePipe } from '@ngx-translate/core';
import { ScannerListStatusPipe } from './list-status.pipe';
import { SimpleScanner } from '../../models/scanner';
import { createOrganizationFilter } from '../organization-filter.util';

_('scanner.title');

@Component({
  templateUrl: 'scanner.component.html',
  selector: 'app-scanner',
  imports: [TranslatePipe, DataTableComponent, EmptyTableComponent],
  providers: [
    NimmstaTimeAgoPipe,
    ScannerStatusPipe,
    ScannerListStatusPipe,
    WorkerNamePipe,
    ScannerDatasource,
  ],
})
export class ScannerComponent implements OnChanges {
  private router = inject(Router);
  private timeago = inject(NimmstaTimeAgoPipe);
  private statusBadge = inject(ScannerStatusPipe);
  private listStatusBadge = inject(ScannerListStatusPipe);
  private workerNamePipe = inject(WorkerNamePipe);
  protected deviceSource = inject(ScannerDatasource);

  @Input() organizationId?: string;

  @ViewChild(DataTableComponent, { static: true })
  private tableComponent?: DataTableComponent<SimpleScanner>;

  protected readonly compactPortraitColumns = [
    'uniqueIdentifier',
    'connectionStatus',
  ];
  get columns(): Column[] {
    return [
      new Column('uniqueIdentifier', 'scanner.serialNr', { sortable: true }),
      new Column('connectionStatus', 'scanner.status', {
        pipe: this.statusBadge,
      }),
      new Column('address', 'scanner.address', { sortable: true }),
      new Column('listStatusSummary', 'scanner.maintenance.summary', {
        pipe: this.listStatusBadge,
      }),
      new Column('lastConnection', 'scanner.lastConnection', {
        pipe: this.timeago,
        sortable: true,
        invertSorting: true,
      }),
      new Column('lastConnectedHandheldId', 'scanner.lastWorkerName', {
        asyncPipe: this.workerNamePipe,
      }),
    ];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['organizationId']) {
      return;
    }

    this.deviceSource.defaultFilter = createOrganizationFilter(
      'organizationId',
      this.organizationId,
    );
    if (!changes['organizationId'].firstChange) {
      this.tableComponent?.loadDataPage(true);
    }
  }

  show(id: string): void {
    this.router.navigate(['/devices/smartwatches', id]);
  }

  emptyButtonClick(): void {
    this.router.navigate(['/users']);
  }
}
